import routes from "routes/routes";

/**
 * Route helpers for the organization-contact surface (#2163).
 *
 * The organization id lives in the URL rather than in Redux, per the house
 * rule that a page gated on a selected entity restores it from the URL and
 * not from `data[0]` — otherwise a deep link or a refresh lands on a blank
 * screen, or worse, on someone else's organization.
 */

export const ORGANIZATION_ID_PARAM = "organizationId";

export const makeOrganizationMembersPath = (organizationId: string): string =>
  routes.accountOrganizationMembersPath.replace(
    `:${ORGANIZATION_ID_PARAM}`,
    encodeURIComponent(organizationId)
  );

/** The organization's booking plan (#3037, M6) — same URL-restore rule. */
export const makeOrganizationBookingsPath = (organizationId: string): string =>
  routes.accountOrganizationBookingsPath.replace(
    `:${ORGANIZATION_ID_PARAM}`,
    encodeURIComponent(organizationId)
  );
